import 'swiper/css/free-mode';

import { SVGIconType } from '../../../constants/svgIcon';
import {
  AlbumNode,
  AlbumNodeProps,
  FadeSwiper,
  SvgIcon,
} from '../../Molecules';

import 'swiper/css';
import styles from './FolderGameSetRow.module.css';

interface FolderGameSetRowProps {
  albumData: AlbumNodeProps[];
  onClickArrow: () => void;
}

export const FolderGameSetRow: React.FC<FolderGameSetRowProps> = ({
  albumData,
  onClickArrow,
}) => {
  return (
    <div className={styles.folderGameSetRow}>
      <div className={styles.listContainer}>
        <FadeSwiper<AlbumNodeProps> items={albumData} noBgFadeEffect={true}>
          {(item: AlbumNodeProps) => <AlbumNode {...item} />}
        </FadeSwiper>
      </div>
      <div className={`${styles.arrowContainer}`} onClick={onClickArrow}>
        <SvgIcon
          name={SVGIconType.Arrow}
          color="#808080"
          width={20}
          height={20}
        />
      </div>
    </div>
  );
};
